import { GET_GM_CAMPAIGNS, GET_GM_CAMPAIGNS_SUCCESS, GET_GM_CAMPAIGNS_ERROR, GET_GM_CAMPAIGNS_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetGmCampaigns = (state = initialState, action) => {
  switch (action.type) {
    case GET_GM_CAMPAIGNS:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_GM_CAMPAIGNS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_GM_CAMPAIGNS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_GM_CAMPAIGNS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetGmCampaigns;
